import {
  FilterType,
  buildExpensableGroupsDataTableFilter,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'

const reportedByFilter = ({ source, expensesContext }: BaseFilterProps) => {
  const options = [
    {
      label: i18n.t('expenses_v2.list.filters.myself'),
      value: 'me',
    },
    {
      label: i18n.t('expenses_v2.list.filters.other_users'),
      value: 'others',
    },
  ]

  return buildExpensableGroupsDataTableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
    identifier: 'expensesList.reportedByFilter',
    path: 'reportedBy',
    title: i18n.t('expenses_v2.list.filters.label_reported_by'),
  })
}

export default reportedByFilter
